const AttachmentView = require('./Attachment.js');
const template       = require('employer/templates/governmentForms/EForms.ejs');
const loader         = require('helpers/loader');
import moment from 'moment';

module.exports = Backbone.View.extend({
    itemViews: null,

    events: {
        'click .js-generate': 'generateForm'
    },

    initialize: function(options) {
        this.itemViews = [];
        this.options = _.defaults(options || {}, {
            attachments: null,
            hideFormEButton: false,
            year: 2025
        });

        this.options.attachments.on('reset add remove', this.render, this);

        this.render();
    },

    render: function() {
        const companyStartYear = moment(app.company.get('createdAt')).year();
        const currentYear = 2025;
        const availableYears = Array(currentYear - companyStartYear + 1).fill(null).map((_, index) => currentYear - index)
            .filter(year => !this.options.attachments.hasTag('period-' + year));

        this.$el.html(template({
            collection: this.options.attachments,
            hideFormEButton: this.options.hideFormEButton,
            availableYears: availableYears,
            year: this.options.year
        }));

        if (this.options.attachments.length > 0) {
            this.options.attachments.forEach(this.renderItem.bind(this));
        } else {
            this.$('.empty-list').removeClass('hidden');
        }

        this.$('.sk-spinner').hide();
        return this;
    },

    renderItem: function(model) {
        var view = new AttachmentView({model: model, mainView: this});

        this.itemViews.push(view);
        this.$('.items').append(view.$el);
    },

    generateForm: function(e) {
        loader.startFullScreen(e.target);
        const year = parseInt(this.$('#year').val() || '2025', 10);

        // Exclude XLSX for year >= 2023
        Promise.all([
            this.model.generateFormE(year),
            this.model.generateFormCp8d('txt', year),
            ...(year < 2023 ? [this.model.generateFormCp8d('excel', year)] : [])
        ])
            .then(() => this.model.fetchAttachments(['E']))
            .then((attachments) => {
                this.options.attachments.add(attachments.models);
                loader.stopLoader();
            });
    },

    remove: function() {
        this.undelegateEvents();
        this.itemViews.forEach(view => view.remove());
    }
});



// WEBPACK FOOTER //
// ./app/employer/views/governmentForms/EForms.js